import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Import utilities
import { useAuth } from 'components/utilities';

// import helpers
import { INITIAL_PROMOTION, getPromotion } from 'helpers/promotions';
import {
	isNumber,
	DEFAULT_PRICE_VALUES,
	NO_AUTH_PAYMENT_METHODS
} from 'helpers/prices';

const useProductPrices = ({ prices_by_payment_methods: productPrices }) => {
	const { isAuth } = useAuth();
	const userPromotions = useSelector(({ promotions }) => promotions.data);
	const userPaymentMethods = useSelector(
		({ auth }) => auth?.authenticate?.payment_methods ?? []
	);

	return useMemo(() => {
		const paymentMethods = isAuth
			? userPaymentMethods
			: NO_AUTH_PAYMENT_METHODS;

		const prices = Object.entries(productPrices).map(([type, methods]) => {
			if (methods) {
				const availableMethods = paymentMethods
					.map((method) => methods[method])
					.filter((method) => method);

				const lowest = _.sortBy(availableMethods, 'price')[0];

				const { price, promotions } = lowest ?? DEFAULT_PRICE_VALUES;

				const promotion =
					isNumber(price) && promotions
						? getPromotion({ price, promotions, userPromotions })
						: INITIAL_PROMOTION;

				return [type, { ...lowest, promotion }];
			}

			return [type, DEFAULT_PRICE_VALUES];
		});

		const availablePrices = prices.filter(([_, { price }]) => isNumber(price));

		return { prices: Object.fromEntries(prices), availablePrices };
		// eslint-disable-next-line
	}, [JSON.stringify(productPrices), JSON.stringify(userPromotions)]);
};

export default useProductPrices;
